(() => {
  const theme = window.Shopify?.theme;
  if (String(theme?.id) !== '206627963228' || theme.role !== 'unpublished') return;
  const id = String(theme.id);
  const retainPreview = () => {
    const current = new URL(location.href);
    if (current.searchParams.get('preview_theme_id') === id) return;
    current.searchParams.set('preview_theme_id', id);
    history.replaceState(history.state, '', current.href);
  };
  retainPreview();
  window.addEventListener('pageshow', retainPreview);
  window.addEventListener('load', retainPreview, {once:true});
  window.addEventListener('popstate', retainPreview);
  window.addEventListener('afterRenderHtmlForFilter', retainPreview);
  const storefront = value => {
    try {
      const url = new URL(value, location.href);
      return url.origin === location.origin && /^https?:$/.test(url.protocol)
        && !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:account|checkout|checkouts|admin|apps|localization)(?:\/|$)/i.test(url.pathname) ? url : null;
    } catch { return null; }
  };
  const decorate = link => {
    const href = link?.getAttribute('href');
    if (!href || href.startsWith('#') || link.hasAttribute('download')) return;
    const url = storefront(href);
    if (!url || url.searchParams.get('preview_theme_id') === id) return;
    url.searchParams.set('preview_theme_id', id);
    link.href = url.href;
  };
  document.querySelectorAll('a[href]').forEach(decorate);
  for (const type of ['pointerdown', 'click', 'auxclick', 'contextmenu', 'focusin']) {
    document.addEventListener(type, event => decorate(event.target.closest?.('a[href]')), true);
  }
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || form.method.toLowerCase() !== 'get') return;
    const url = storefront(form.action);
    if (!url || !/\/search\/?$/.test(url.pathname)) return;
    let input = form.querySelector('input[name="preview_theme_id"]');
    if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = 'preview_theme_id'; form.append(input); }
    input.value = id;
  }, true);
})();

(() => {
  if (String(window.Shopify?.theme?.id) !== '206627963228') return;
  const selector = '#boost-sd-filter-tree-column';
  const controls = 'button,input,select,a[href],[tabindex]';
  const visible = element => Boolean(element?.isConnected && element.getClientRects().length
    && getComputedStyle(element).visibility !== 'hidden' && !element.disabled);
  const desktop = () => !visible(document.getElementById('boost-sd__filter-tree-toggle-button'));
  const style = document.createElement('style');
  style.textContent = '#boost-sd-filter-tree-column :is(button,input,select,a[href]):focus-visible{outline:2px solid #074635!important;outline-offset:3px!important}';
  document.head.append(style);
  let root, remembered, frame;
  const remember = element => {
    let filter;
    try { filter = JSON.parse(element.getAttribute('metadata'))?.action?.clearFilter; } catch {}
    const chipLabel = element.querySelector('.boost-sd__refine-by-vertical-refine-by-value')?.textContent.trim();
    const related = filter && [...root.querySelectorAll('[data-action]')].find(button =>
      button.getAttribute('data-action').startsWith(filter.key + '.')
      && button.querySelector('.boost-sd__filter-option-item-label')?.textContent.trim() === chipLabel);
    remembered = {element, id: element.id, action: element.getAttribute('data-action') || related?.getAttribute('data-action'),
      group: element.closest('.boost-sd__filter-option')?.getAttribute('data-filteroptionid')};
  };
  const sync = () => {
    frame = null;
    if (!desktop() || !visible(root) || !remembered) return;
    const active = document.activeElement;
    if (active === remembered.element && visible(active)) return;
    if (active !== document.body && visible(active)) { remembered = null; return; }
    const candidates = [...root.querySelectorAll(controls)].filter(visible);
    const {action, id, group} = remembered;
    const replacement = candidates.find(element => action ? element.getAttribute('data-action') === action : id && element.id === id)
      || candidates.find(element => group && element.closest('.boost-sd__filter-option')?.getAttribute('data-filteroptionid') === group)
      || candidates.find(element => element.getAttribute('role') === 'checkbox')
      || candidates[0];
    if (replacement) replacement.focus({preventScroll: true});
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(sync); };
  document.addEventListener('focusin', event => {
    if (desktop() && root?.contains(event.target) && visible(event.target)) remember(event.target);
    else if (event.target !== document.body && visible(event.target)) remembered = null;
  }, true);
  document.addEventListener('pointerdown', event => {
    if (!root?.contains(event.target)) remembered = null;
  }, true);
  // Boost 1.52 can reuse mobile HTML after an AJAX redraw and retain its
  // page-local "first desktop render" flag after replacing the filter DOM.
  // Re-enter its native resize/lazy-render path instead of cloning options
  // or forcing the empty column visible. No persisted app setting is changed.
  let refreshColumn;
  let productGrid;
  const reconcileGrid = () => {
    if (!productGrid?.isConnected || document.querySelector('.boost-sd__view-as-icon')) return;
    const settings = window.__BOOST_TAE_LIQUID__?.templateSettings?.themeSettings?.productList;
    const columns = Number(settings?.[desktop() ? 'productsPerRowOnDesktop' : 'productsPerRowOnMobile']);
    if (!Number.isInteger(columns) || columns < 1 || columns > 6) return;
    const gridClasses = [...productGrid.classList].filter(name => /^boost-sd__product-list-(?:grid--\d+|undefined)-col$/.test(name));
    if (!gridClasses.length) return;
    const expected = 'boost-sd__product-list-grid--' + columns + '-col';
    for (const name of gridClasses) if (name !== expected) productGrid.classList.remove(name);
    if (!productGrid.classList.contains(expected)) productGrid.classList.add(expected);
  };
  const gridObserver = new MutationObserver(reconcileGrid);
  const reconcileViewport = () => {
    const toggle = document.getElementById('boost-sd__filter-tree-toggle-button');
    if (!root?.isConnected || !toggle
      || !root.closest('.boost-sd-layout--has-vertical-style-default')) return;
    if (visible(toggle)) { refreshColumn = null; return; }
    const missingOptions = !root.querySelector('.boost-sd__filter-option-item-button')
      && document.querySelector('#boost-sd_filter-tree-mobile .boost-sd__filter-option-item-button');
    if (root.style.display !== 'none' && !missingOptions) { refreshColumn = null; return; }
    if (refreshColumn === root) return;
    const column = root;
    refreshColumn = column;
    window.renderFilterTreeFirstLoad = false;
    if (missingOptions) column.style.display = 'none';
    requestAnimationFrame(() => {
      if (column.isConnected && desktop() && column.style.display === 'none') {
        window.dispatchEvent(new Event('resize'));
      }
    });
  };
  const columnObserver = new MutationObserver(() => {
    reconcileViewport();
    schedule();
  });
  const connect = () => {
    const next = document.querySelector(selector);
    const nextGrid = document.querySelector('.boost-sd-layout--has-vertical-style-default .boost-sd__product-list');
    if (nextGrid && nextGrid !== productGrid) {
      gridObserver.disconnect();
      productGrid = nextGrid;
      gridObserver.observe(productGrid, {attributes: true, attributeFilter: ['class']});
    }
    reconcileGrid();
    if (next && next !== root) {
      columnObserver.disconnect();
      root = next;
      columnObserver.observe(root, {attributes: true, attributeFilter: ['style']});
    }
    reconcileViewport();
    schedule();
    return Boolean(next);
  };
  new MutationObserver(records => {
    if (!root?.isConnected || !productGrid?.isConnected || records.some(record => root.contains(record.target))) connect();
  }).observe(document.body, {childList: true, subtree: true});
  connect();
  window.addEventListener('afterRenderHtmlForFilter', connect);
  window.addEventListener('resize', () => {
    connect();
    if (!desktop()) remembered = null;
  });
})();

(() => {
  if (!['206627963228', '206763196764'].includes(String(window.Shopify?.theme?.id)) || !document.body.classList.contains('template-product') || document.querySelector('[data-gl2-gift-offer]')) return;
  const mobile = matchMedia('(max-width: 767px)');
  let host, slot, frame;
  const original = new Map();
  const setStyle = (element, name, value) => {
    if (element.style.getPropertyValue(name) !== value) element.style.setProperty(name, value);
  };
  const position = () => {
    frame = null;
    if (!host?.isConnected) return;
    const product = document.querySelector('.product-single-wrapper');
    const teaser = host.shadowRoot?.querySelector('#app-embed[data-current-step="tease"]');
    if (mobile.matches && product && teaser && getComputedStyle(host).display !== 'none') {
      if (!slot) {
        slot = document.createElement('div');
        slot.style.cssText = 'display:block!important;width:calc(100% - 32px);max-width:450px;margin:12px auto';
        slot.setAttribute('role', 'presentation');
        product.before(slot);
        resize.observe(slot);
      }
      slot.hidden = false;
      if (slot.style.display !== 'block') slot.style.setProperty('display', 'block', 'important');
      const rect = slot.getBoundingClientRect();
      setStyle(host, 'position', 'absolute');
      setStyle(host, 'top', (rect.top + scrollY) + 'px');
      setStyle(host, 'left', (rect.left + scrollX) + 'px');
      setStyle(host, 'width', rect.width + 'px');
      setStyle(host, 'margin', '0px');
      setStyle(slot, 'height', Math.ceil(teaser.getBoundingClientRect().height) + 'px');
    } else {
      if (slot) { slot.hidden = true; slot.style.setProperty('display', 'none', 'important'); }
      for (const [name, value] of original) {
        if (value) setStyle(host, name, value);
        else if (host.style.getPropertyValue(name)) host.style.removeProperty(name);
      }
    }
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(position); };
  const resize = new ResizeObserver(schedule);
  const connect = () => {
    const next = document.getElementById('app-embed-container-1132889');
    if (!next?.shadowRoot) return false;
    if (host === next) { schedule(); return true; }
    host = next;
    for (const name of ['position', 'top', 'left', 'width', 'margin']) original.set(name, host.style.getPropertyValue(name));
    if (!host.shadowRoot.querySelector('[data-gl-product-teaser]')) {
      const style = document.createElement('style');
      style.dataset.glProductTeaser = '';
      style.textContent = `@media(max-width:767px){
        #app-embed[data-current-step="tease"]{position:relative!important;inset:auto!important;width:100%!important;max-width:100%!important;padding:0!important;transform:none!important;rotate:none!important;z-index:auto!important}
        #app-embed[data-current-step="tease"] [data-testid="app-router"]{width:100%;transform:none!important;rotate:none!important;translate:none!important;animation:none!important}
        #app-embed[data-current-step="tease"] [data-testid="form-teaser"]{box-sizing:border-box;width:100%;min-height:48px;white-space:normal;text-align:center}
        #app-embed[data-current-step="tease"] [data-testid="form-teaser"]:focus-visible{outline:2px solid #074635;outline-offset:3px}
      }`;
      host.shadowRoot.append(style);
    }
    new MutationObserver(schedule).observe(host.shadowRoot, {childList:true,subtree:true,attributes:true,attributeFilter:['data-current-step','class','style']});
    resize.observe(host);
    resize.observe(document.body);
    schedule();
    return true;
  };
  if (!connect()) {
    const discovery = new MutationObserver(() => { if (connect()) discovery.disconnect(); });
    discovery.observe(document.body, {childList: true, subtree: true});
    window.addEventListener('load', () => { if (connect()) discovery.disconnect(); }, {once: true});
  }
  mobile.addEventListener('change', schedule);
  window.addEventListener('resize', schedule);
})();
// Preserve the native Envy drawer and restore its exact Living Gallery trigger.
(() => {
  const root = document.querySelector('.gl-living-root') || document.querySelector('#PageContainer');
  const drawer = document.querySelector('cart-drawer');
  if (!root || !drawer || root.dataset.cartType !== 'drawer') return;
  let origin = null;
  let wasOpen = false;
  let revision = 0;
  const available = element => element?.isConnected && element.getClientRects().length
    && !element.closest('[hidden], [inert]') && getComputedStyle(element).visibility !== 'hidden';

  const triggers = [...root.querySelectorAll('.site-header .cart, a.js-drawer-open-right-link[aria-controls="CartDrawer"]')];
  triggers.forEach(trigger => {
  trigger?.addEventListener('keydown', event => {
    if (event.key !== 'Enter' || event.repeat || typeof window.eventBus?.emit !== 'function') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    origin = trigger;
    revision += 1;
    window.eventBus.emit('open:cart:drawer', {scrollToTop: false});
  }, true);
  trigger.addEventListener('keyup', event => {
    if (event.key === 'Enter') { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);
  trigger?.addEventListener('click', event => {
    if (typeof window.eventBus?.emit !== 'function') return;
    origin = event.currentTarget;
    revision += 1;
    if (trigger.matches('.site-header .cart')) {
      event.preventDefault();
      window.eventBus.emit('open:cart:drawer', {scrollToTop: false});
    }
  }, true);
  });

  new MutationObserver(() => {
    const open = drawer.getAttribute('aria-hidden') === 'false';
    triggers.forEach(trigger => trigger.setAttribute('aria-expanded', String(open)));
    if (open) {
      if (!wasOpen && origin) requestAnimationFrame(() => {
        if (drawer.getAttribute('aria-hidden') === 'false') drawer.querySelector('[data-drawer-close]')?.focus({preventScroll: true});
      });
      wasOpen = true; return;
    }
    if (!wasOpen) return;
    wasOpen = false;
    const target = origin;
    const closingRevision = revision;
    origin = null;
    requestAnimationFrame(() => {
      if (closingRevision !== revision || drawer.getAttribute('aria-hidden') === 'false') return;
      if (document.querySelector('dialog[open], .global-drawer[aria-hidden="false"]')) return;
      if (available(target)) target.focus({preventScroll: true});
    });
  }).observe(drawer, {attributes: true, attributeFilter: ['aria-hidden']});

  // The native trap includes hidden recommendation controls. Bound the visible
  // controls only when this drawer was opened from the new Gallery header.
  drawer.addEventListener('keydown', event => {
    if (event.key === 'Escape' && origin && drawer.getAttribute('aria-hidden') === 'false') {
      event.preventDefault(); event.stopImmediatePropagation();
      drawer.querySelector('[data-drawer-close]')?.click();
      return;
    }
    if (event.key !== 'Tab' || !origin || drawer.getAttribute('aria-hidden') !== 'false') return;
    const items = [...drawer.querySelectorAll('a[href], button, input, select, textarea, [tabindex]')]
      .filter(element => element.tabIndex >= 0 && !element.disabled && available(element)
        && !element.closest('[aria-hidden="true"]'));
    if (!items.length) return;
    const active = document.activeElement;
    let target = null;
    if (event.shiftKey && (active === items[0] || !items.includes(active))) target = items.at(-1);
    if (!event.shiftKey && (active === items.at(-1) || !items.includes(active))) target = items[0];
    if (target) {
      event.preventDefault();
      event.stopImmediatePropagation();
      target.focus({preventScroll: true});
    }
  }, true);
})();

// Use Shopify Inbox's existing custom element show() method. No message is sent.
// Hide its floating activator only after these inline launchers are available.
(() => {
  const root = document.querySelector('.gl-living-root');
  const triggers = [...(root?.querySelectorAll('[data-chat-open]') || [])];
  if (!root || !triggers.length) return;
  const connect = () => {
    const chat = document.querySelector('shopify-chat');
    if (!chat || typeof chat.show !== 'function') return false;
    let origin = null;
    let wasOpen = chat.hasAttribute('open');
    for (const trigger of triggers) {
      trigger.hidden = false;
      trigger.addEventListener('click', () => { origin = trigger; chat.show(); });
    }
    document.body.classList.add('gl-chat-inline');
    new MutationObserver(() => {
      const open = chat.hasAttribute('open');
      if (wasOpen && !open) {
        const target = origin;
        origin = null;
        requestAnimationFrame(() => {
          if (!chat.hasAttribute('open') && target?.isConnected && target.getClientRects().length) {
            target.focus({preventScroll: true});
          }
        });
      }
      wasOpen = open;
    }).observe(chat, {attributes: true, attributeFilter: ['open']});
    return true;
  };
  customElements.whenDefined('shopify-chat').then(() => {
    if (connect()) return;
    const observer = new MutationObserver(() => { if (connect()) observer.disconnect(); });
    observer.observe(document.body, {childList: true, subtree: true});
  });
})();

// Draft-only bridge to the store's existing Orbe popup. Country/language lists,
// localization submission and routing remain owned by Orbe and Shopify.
(() => {
  const root = document.querySelector('.gl-living-root');
  if (!root) return;
  const triggers = [...root.querySelectorAll('[data-gl-localization]')];
  let connected = false;
  const connect = () => {
    if (connected) return true;
    const modal = document.getElementById('md-app-embed__modal');
    if (!modal || typeof orbito === 'undefined' || typeof orbito.openModalWithoutRefresh !== 'function') return false;
    let origin = null;
    let placeholder = null;
    let galleryTop = 0;
    const gallery = root.querySelector('#gallery');
    const visible = el => el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden';
    const english = /^en(?:-|$)/i.test(document.documentElement.lang);
    const localizeLabels = () => {
      const labels = english ? {
        '[data-mdapptitle]': 'Country and language',
        '[data-mdapptext]': 'Choose your delivery country and language.',
        '[data-mdapphelpertext]': 'Orders can only be shipped to addresses in the selected country.',
        '[data-mdappcountrylabel]': 'Country', '[data-mdapplanguagelabel]': 'Language',
        '[data-mdappctatext]': 'Confirm choices'
      } : {
        '[data-mdapptitle]': 'Χώρα και γλώσσα',
        '[data-mdapptext]': 'Επίλεξε χώρα παράδοσης και γλώσσα.',
        '[data-mdapphelpertext]': 'Οι παραγγελίες μπορούν να αποσταλούν μόνο σε διευθύνσεις της επιλεγμένης χώρας.',
        '[data-mdappcountrylabel]': 'Χώρα', '[data-mdapplanguagelabel]': 'Γλώσσα',
        '[data-mdappctatext]': 'Επιβεβαίωση επιλογών'
      };
      for (const [selector, text] of Object.entries(labels)) {
        const element = modal.querySelector(selector);
        if (element && element.textContent !== text) element.textContent = text;
      }
      modal.querySelector('.md-modal-closeButton')?.setAttribute('aria-label', english ? 'Cancel and close' : 'Ακύρωση και κλείσιμο');
    };
    for (const trigger of triggers) {
      trigger.disabled = false;
      trigger.removeAttribute('aria-busy');
      trigger.addEventListener('click', () => {
        origin = trigger;
        // A native modal dialog makes its siblings inert. Move the same Orbe
        // element into it temporarily; never clone or create a second popup.
        if (gallery?.open) {
          galleryTop = gallery.scrollTop;
          placeholder = document.createComment('Orbe original position');
          modal.before(placeholder);
          gallery.append(modal);
        }
        const url = new URL(location.href);
        if (String(window.Shopify?.theme?.id) === '206627963228') {
          url.searchParams.set('preview_theme_id', '206627963228');
          history.replaceState(history.state, '', url);
        }
        orbito.openModalWithoutRefresh();
        localizeLabels();
        trigger.setAttribute('aria-expanded', 'true');
      });
    }
    // Observe the vendor's completed close, including its own Escape/cancel.
    new MutationObserver(() => {
      if (!origin || modal.getAttribute('aria-hidden') !== 'true') return;
      const target = origin;
      origin = null;
      target.setAttribute('aria-expanded', 'false');
      if (placeholder) { placeholder.replaceWith(modal); placeholder = null; }
      if (gallery?.open) gallery.scrollTop = galleryTop;
      requestAnimationFrame(() => { if (target.isConnected && visible(target)) target.focus({preventScroll: true}); });
    }).observe(modal, {attributes: true, attributeFilter: ['aria-hidden']});
    // Bound keyboard navigation to visible vendor controls, including open
    // country/language lists. The existing vendor handles selection and Escape.
    modal.addEventListener('keydown', event => {
      if (!origin || event.key !== 'Tab') return;
      const items = [...modal.querySelectorAll('button:not([disabled]),a[href],input:not([type="hidden"]),[tabindex="0"]')].filter(visible);
      const active = document.activeElement;
      const target = event.shiftKey && (active === items[0] || !items.includes(active)) ? items.at(-1)
        : !event.shiftKey && (active === items.at(-1) || !items.includes(active)) ? items[0] : null;
      if (target) { event.preventDefault(); event.stopImmediatePropagation(); target.focus({preventScroll: true}); }
    }, true);
    connected = true;
    return true;
  };
  if (connect()) return;
  const observer = new MutationObserver(() => { if (connect()) observer.disconnect(); });
  observer.observe(document.body, {childList: true, subtree: true});
  window.addEventListener('load', () => { if (connect()) observer.disconnect(); }, {once: true});
})();

// Preserve the open mobile style-2 panel after Boost 1.52 redraws its options.
// Boost retains --full-height on the active group, but also adds --hidden to it
// and drops --hidden from sibling groups. Reconcile only those display classes;
// the vendor still owns navigation, labels, selected filters and result updates.
(() => {
  if (String(window.Shopify?.theme?.id) !== '206627963228') return;
  const rootSelector = '#boost-sd_filter-tree-mobile';
  const wrapperClass = 'boost-sd__filter-option-itemwrapper';
  const fullHeight = wrapperClass + '--full-height';
  const hidden = wrapperClass + '--hidden';
  let root;
  let queued = false;
  const sync = () => {
    queued = false;
    if (!root?.isConnected || !root.getClientRects().length
      || !document.getElementById('boost-sd__filter-tree-toggle-button')?.getClientRects().length
      || !root.classList.contains('boost-sd_filter-tree-mobile--style2')) return;
    const active = root.querySelector('.' + fullHeight);
    if (!active) return; // The vendor has returned to the list of filter groups.
    root.querySelectorAll('.' + wrapperClass).forEach(wrapper => {
      const shouldHide = wrapper !== active;
      if (wrapper.classList.contains(hidden) !== shouldHide) {
        wrapper.classList.toggle(hidden, shouldHide);
      }
    });
  };
  const schedule = () => {
    if (!queued) { queued = true; queueMicrotask(sync); }
  };
  const panelObserver = new MutationObserver(schedule);
  const connect = () => {
    const next = document.querySelector(rootSelector);
    if (next && next !== root) {
      panelObserver.disconnect();
      root = next;
      panelObserver.observe(root, {childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style']});
    }
    schedule();
    return Boolean(next);
  };
  if (!connect()) {
    const discovery = new MutationObserver(() => { if (connect()) discovery.disconnect(); });
    discovery.observe(document.body, {childList: true, subtree: true});
  }
  window.addEventListener('afterRenderHtmlForFilter', connect);
  window.addEventListener('resize', schedule);
})();

// Keep keyboard focus in the mobile panel across Boost's asynchronous redraws.
// Desktop and mobile copies share IDs, so resolve replacements inside the mobile
// root only. Native buttons still own closing, scroll unlocking and filtering.
(() => {
  if (String(window.Shopify?.theme?.id) !== '206627963228') return;
  const rootSelector = '#boost-sd_filter-tree-mobile';
  const trigger = () => document.getElementById('boost-sd__filter-tree-toggle-button');
  // Boost explicitly removes this trigger's outline with !important.
  const focusStyle = document.createElement('style');
  focusStyle.textContent = '#boost-sd_filter-tree-mobile :is(button,input,select,a[href]):focus-visible,#boost-sd__filter-tree-toggle-button:focus-visible,#boost-sd__filter-tree-toggle-button.focus-visible{outline:2px solid currentColor!important;outline-offset:3px}';
  document.head.append(focusStyle);
  const visible = element => Boolean(element?.isConnected && element.getClientRects().length
    && getComputedStyle(element).visibility !== 'hidden');
  let root, origin, returned, remembered, pending, frame;
  let wasOpen = false;
  const isOpen = () => visible(root) && visible(trigger());
  const remember = element => {
    remembered = element ? {element, id: element.id, action: element.getAttribute('data-action'),
      group: element.closest('.boost-sd__filter-option')?.getAttribute('data-filteroptionid')} : null;
  };
  const focus = element => {
    if (!visible(element)) return;
    element.focus({preventScroll: true});
    // A redraw may reset the vendor's scroll container. Preserve its position
    // when the control is on screen; reveal it only when it fell out of view.
    const rect = element.getBoundingClientRect();
    if (root?.contains(element) && (rect.top < 0 || rect.bottom > window.innerHeight)) {
      element.scrollIntoView({block: 'center', inline: 'nearest', behavior: 'instant'});
    }
  };
  const sync = () => {
    frame = null;
    const open = isOpen();
    if (!open && wasOpen && pending && visible(trigger())
      && document.body.classList.contains('boost-sd__g-no-scroll')) return;
    if (pending) remembered = pending;
    if (open !== wasOpen) {
      wasOpen = open;
      remembered = pending || null;
      trigger()?.setAttribute('aria-expanded', String(open));
      if (open) {
        returned = null;
        origin = trigger();
        if (pending) schedule();
        else if (root.contains(document.activeElement) && visible(document.activeElement)) remember(document.activeElement);
        else focus(root.querySelector('.boost-sd__button--close'));
      } else {
        pending = null;
        const target = origin;
        origin = null;
        returned = visible(target) ? target : trigger();
        focus(returned);
      }
      return;
    }
    if (!open) {
      // A response already in flight can also replace the opening button after
      // Escape. Follow that replacement only until the visitor moves again.
      if (returned && !returned.isConnected && document.activeElement === document.body) {
        returned = trigger();
        focus(returned);
      }
      return;
    }
    if (!remembered) return;
    const active = document.activeElement;
    if (active === remembered.element && visible(active)) return;
    // Never pull focus back after the visitor deliberately moves elsewhere.
    if (!pending && active !== document.body && visible(active) && !root.contains(active)) return;
    const {element, action, id, group} = remembered;
    const candidates = [...root.querySelectorAll('button,input,select,a[href],[tabindex]')];
    let replacement = visible(element) ? element : candidates.find(candidate => visible(candidate)
      && (action ? candidate.getAttribute('data-action') === action : id && candidate.id === id));
    if (!replacement) {
      const option = [...root.querySelectorAll('.boost-sd__filter-option')]
        .find(candidate => candidate.getAttribute('data-filteroptionid') === group);
      replacement = [...(option?.querySelectorAll('button,input,[tabindex="0"]') || [])].find(visible)
        || candidates.find(candidate => candidate.classList.contains('boost-sd__button--back') && visible(candidate))
        || candidates.find(candidate => candidate.classList.contains('boost-sd__button--close') && visible(candidate));
    }
    if (replacement !== document.activeElement) focus(replacement);
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(sync); };
  document.addEventListener('focusin', event => {
    if (pending) return;
    if (!isOpen()) {
      if (event.target !== trigger() && event.target !== document.body && visible(event.target)) returned = null;
      return;
    }
    if (root.contains(event.target)) remember(event.target);
    else if (event.target !== document.body && visible(event.target)) remembered = null;
  }, true);
  document.addEventListener('pointerdown', event => {
    pending = null;
    returned = null;
    if (isOpen() && !root.contains(event.target)) remembered = null;
  }, true);
  document.addEventListener('click', event => {
    if (!isOpen() || !root.contains(event.target)) return;
    const button = event.target.closest('button');
    if (button?.classList.contains('boost-sd__button--close')) {
      pending = null;
      remembered = null;
    } else if (button?.classList.contains('boost-sd__button--back')) {
      pending = null;
      const group = root.querySelector('.boost-sd__filter-option-itemwrapper--full-height')
        ?.closest('.boost-sd__filter-option');
      remember(group?.querySelector('.boost-sd__filter-option-title'));
    } else if (button) {
      remember(button);
      pending = remembered;
    }
    schedule();
  }, true);
  document.addEventListener('keydown', event => {
    if (event.key === 'Tab') { pending = null; returned = null; }
    if (event.key !== 'Escape' || !isOpen()
      || (document.activeElement !== document.body && !root.contains(document.activeElement))) return;
    const close = root.querySelector('.boost-sd__button--close');
    if (!visible(close)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    pending = null;
    remembered = null;
    close.click();
    schedule();
  }, true);
  const observer = new MutationObserver(schedule);
  const connect = () => {
    const next = document.querySelector(rootSelector);
    if (next && next !== root) {
      observer.disconnect();
      root = next;
      observer.observe(root, {childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style']});
    }
    schedule();
    return Boolean(next);
  };
  if (!connect()) {
    const discovery = new MutationObserver(() => { if (connect()) discovery.disconnect(); });
    discovery.observe(document.body, {childList: true, subtree: true});
  }
  window.addEventListener('afterRenderHtmlForFilter', connect);
  window.addEventListener('resize', () => {
    if (!visible(trigger())) pending = null;
    schedule();
  });
})();

// Draft-only accessibility correction. Boost's applied-filter chips also cover
// SSR reloads where the selected button class is missing. No filter writes.
(() => {
  const selector = '.boost-sd__filter-option-item-button[role="checkbox"]';
  const chipSelector = '.boost-sd__refine-by-vertical-refine-by-item[metadata]';
  const normalize = text => (text || '').trim().replace(/\s+/g, ' ');
  let queued = false;
  const sync = () => {
    queued = false;
    const applied = new Set();
    document.querySelectorAll(chipSelector).forEach(chip => {
      try {
        const filter = JSON.parse(chip.getAttribute('metadata')).action.clearFilter;
        const label = normalize(chip.querySelector('.boost-sd__refine-by-vertical-refine-by-value')?.textContent);
        if (filter.key && label) applied.add(filter.key + '\0' + label);
      } catch { /* Ignore unrelated or incomplete vendor metadata. */ }
    });
    document.querySelectorAll(selector).forEach(button => {
      const key = (button.dataset.action || '').split('.')[0];
      const label = normalize(button.querySelector('.boost-sd__filter-option-item-label')?.textContent);
      const checked = String(button.classList.contains('boost-sd__filter-option-item-button--selected') || applied.has(key + '\0' + label));
      if (button.getAttribute('aria-checked') !== checked) button.setAttribute('aria-checked', checked);
    });
  };
  const schedule = () => { if (!queued) { queued = true; queueMicrotask(sync); } };
  new MutationObserver(records => {
    if (records.some(record => record.type === 'childList'
      ? [...record.addedNodes, ...record.removedNodes].some(node => node.nodeType === 1 && (node.matches?.(selector + ',' + chipSelector) || node.querySelector?.(selector + ',' + chipSelector))) || record.target.closest?.('.boost-sd__refine-by-vertical-refine-by-list')
      : record.type === 'characterData' ? record.target.parentElement?.closest(selector + ',' + chipSelector)
      : record.target.matches(selector))) schedule();
  }).observe(document.body, {childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['class', 'aria-checked']});
  sync();
})();

// Boost 1.52 dereferences null metadata on direct keyboard activation of links.
// Supply its existing navigation action explicitly, preserving its product handler.
document.addEventListener('click', event => {
  const target = event.target;
  if (!(target instanceof Element) || !target.matches('a[href]')
    || !target.closest('.main-content') || target.hasAttribute('data-metadata')
    || target.hasAttribute('metadata')) return;
  if (target.matches('.boost-sd__product-link')
    && target.closest('.boost-sd__product-item, .boost-sd__product-item-list-view-layout')
    && !target.closest('.boost-sd__popup-select-option, .boost-sd__product-swatch, .boost-sd__bulk-quantity')) {
    target.setAttribute('data-metadata', JSON.stringify({action: {goToProductDetail: null}}));
  } else if (target.matches('.boost-sd__search-result-panel-content-item, .boost-sd__pagination-number, .boost-sd__pagination-button')) {
    target.setAttribute('data-metadata', '{}');
  }
}, true);


// Keep the mobile filter trigger as the Escape destination through a pending
// Boost response. All filter changes and closing still use Boost's own handlers.
(() => {
  if (String(window.Shopify?.theme?.id) !== '206763196764') return;
  const triggerSelector = '#boost-sd__filter-tree-toggle-button';
  const panelSelector = '#boost-sd_filter-tree-mobile';
  const focusStyle = document.createElement('style');
  focusStyle.textContent = `${triggerSelector}:focus-visible { outline: 2px solid #284d3e !important; outline-offset: 3px; }`;
  document.head.appendChild(focusStyle);
  const visible = element => Boolean(element?.isConnected && element.getClientRects().length
    && getComputedStyle(element).visibility !== 'hidden');
  let returning = false;
  let frame = 0;
  let departed;
  let tabbing = false;
  let destination = null;
  const trigger = () => document.querySelector(triggerSelector);
  const panel = () => document.querySelector(panelSelector);
  const cardSelector = '.boost-sd__product-item, .boost-sd__product-item-list-view-layout';
  const cards = () => Array.from(document.querySelectorAll(`.main-content ${cardSelector.split(', ').join(', .main-content ')}`)).filter(visible);
  const remember = element => {
    const card = element.closest(cardSelector);
    const links = card ? Array.from(card.querySelectorAll('a.boost-sd__product-link')).filter(visible) : [];
    destination = {element, id: element.id, href: element.getAttribute('href'),
      cardIndex: card ? cards().indexOf(card) : -1, linkIndex: links.indexOf(element)};
  };
  const resolve = () => {
    if (!destination) return trigger();
    if (visible(destination.element)) return destination.element;
    if (destination.id) {
      const element = document.getElementById(destination.id);
      if (visible(element)) return element;
    }
    if (destination.cardIndex >= 0 && destination.linkIndex >= 0) {
      const list = cards();
      const card = list.find(item => Array.from(item.querySelectorAll('a.boost-sd__product-link'))
        .some(link => link.getAttribute('href') === destination.href))
        || list[Math.min(destination.cardIndex, list.length - 1)];
      const links = card ? Array.from(card.querySelectorAll('a.boost-sd__product-link')).filter(visible) : [];
      return links[Math.min(destination.linkIndex, links.length - 1)] || trigger();
    }
    return trigger();
  };
  const observer = new MutationObserver(() => schedule());
  const cancel = () => {
    returning = false;
    departed = null;
    tabbing = false;
    destination = null;
    observer.disconnect();
    if (frame) cancelAnimationFrame(frame);
    frame = 0;
  };
  const restore = () => {
    frame = 0;
    if (!returning) return;
    const target = resolve();
    if (!visible(target)) { cancel(); return; }
    const active = document.activeElement;
    // Only repair the vendor's fallback focus, never a visitor's new control.
    const fallback = active === document.body || active === departed
      || !active?.isConnected || !visible(active)
      || active.matches('h1, [role="main"], main, #PageContainer')
      || Boolean(active.closest(panelSelector));
    if (active !== target && fallback) {
      if (destination) destination.element = target;
      target.focus({preventScroll: true});
    }
  };
  const schedule = () => {
    if (returning && !frame) frame = requestAnimationFrame(restore);
  };
  document.addEventListener('keydown', event => {
    if (returning && event.key === 'Tab') {
      // Complete Escape restoration before the browser performs its native Tab.
      // Then remember the actual destination, not the discarded filter control.
      if (frame) cancelAnimationFrame(frame);
      restore();
      tabbing = returning;
      return;
    }
    if (event.key !== 'Escape') { cancel(); return; }
    const active = document.activeElement;
    const root = panel();
    if (!visible(trigger()) || !root || !(root.contains(active)
      || (visible(root) && active === document.body))) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    departed = active;
    destination = null;
    tabbing = false;
    returning = true;
    observer.observe(document.querySelector('.main-content') || document.body,
      {childList: true, subtree: true});
    root.querySelector('.boost-sd__button--close')?.click();
    schedule();
  }, true);
  document.addEventListener('keyup', event => {
    if (event.key === 'Tab') tabbing = false;
    if (returning && event.key === 'Escape') {
      event.preventDefault();
      event.stopImmediatePropagation();
      schedule();
    }
  }, true);
  document.addEventListener('pointerdown', cancel, true);
  document.addEventListener('focusin', event => {
    if (!returning) return;
    const target = event.target;
    if (tabbing) {
      tabbing = false;
      if (target === trigger()) destination = null;
      else if (target.closest('.main-content') && !target.closest(panelSelector)) remember(target);
      else cancel();
      return;
    }
    if (target === trigger() || target === destination?.element) return;
    if (target === departed || target === document.body
      || target.matches('h1, [role="main"], main, #PageContainer')
      || target.closest(panelSelector)) schedule();
    else cancel();
  }, true);
  window.addEventListener('afterRenderHtmlForFilter', schedule);
  window.addEventListener('resize', () => { if (!visible(trigger())) cancel(); });
})();

// Reconcile Boost's page-local layout after breakpoint changes and AJAX redraws.
// Keep its native rendering/close handlers; do not change persisted app settings.
(() => {
  if (String(window.Shopify?.theme?.id) !== '206763196764') return;
  const columnSelector = '#boost-sd-filter-tree-column';
  const visible = element => Boolean(element?.isConnected && element.getClientRects().length
    && getComputedStyle(element).visibility !== 'hidden');
  let refreshedColumn;
  let wasMobile;
  let frame;
  const sync = () => {
    frame = null;
    const column = document.querySelector(columnSelector);
    const toggle = document.getElementById('boost-sd__filter-tree-toggle-button');
    if (!column || !toggle || !column.closest('.boost-sd-layout--has-vertical-style-default')) return;
    const mobile = visible(toggle);
    const panel = document.getElementById('boost-sd_filter-tree-mobile');
    if (wasMobile === true && !mobile && visible(panel)) {
      const focused = panel.contains(document.activeElement) ? document.activeElement.id : null;
      panel.querySelector('.boost-sd__button--close')?.click();
      if (focused) {
        const replacement = Array.from(column.querySelectorAll('[id]')).find(element => element.id === focused && visible(element));
        if (replacement) replacement.focus({preventScroll: true});
      }
    }
    wasMobile = mobile;
    if (mobile) {
      refreshedColumn = null;
      if (column.style.display !== 'none') column.style.display = 'none';
    } else {
      const missingOptions = !column.querySelector('.boost-sd__filter-option-item-button')
        && panel?.querySelector('.boost-sd__filter-option-item-button');
      if ((column.style.display === 'none' || missingOptions) && refreshedColumn !== column) {
        refreshedColumn = column;
        window.renderFilterTreeFirstLoad = false;
        column.style.display = 'none';
        requestAnimationFrame(() => {
          if (column.isConnected && !visible(toggle)) window.dispatchEvent(new Event('resize'));
        });
      }
    }
    const grid = document.querySelector('.boost-sd-layout--has-vertical-style-default .boost-sd__product-list');
    if (grid && !document.querySelector('.boost-sd__view-as-icon')) {
      const settings = window.__BOOST_TAE_LIQUID__?.templateSettings?.themeSettings?.productList;
      const count = Number(settings?.[mobile ? 'productsPerRowOnMobile' : 'productsPerRowOnDesktop']);
      if (Number.isInteger(count) && count >= 1 && count <= 6) {
        const expected = 'boost-sd__product-list-grid--' + count + '-col';
        for (const name of Array.from(grid.classList)) {
          if (/^boost-sd__product-list-(?:grid--\d+|undefined)-col$/.test(name) && name !== expected) grid.classList.remove(name);
        }
        grid.classList.add(expected);
      }
    }
  };
  // Some mobile-origin renders retain an empty desktop collapse-state map.
  // Let Boost handle the click first, then repair only a no-op disclosure.
  document.addEventListener('click', event => {
    const button = event.target.closest?.(columnSelector + ' .boost-sd__filter-option-title');
    if (!button || visible(document.getElementById('boost-sd__filter-tree-toggle-button'))) return;
    const group = button.closest('.boost-sd__filter-option');
    const wrapper = group?.querySelector('.boost-sd__filter-option-itemwrapper');
    const label = button.closest('.boost-sd__filter-option-label');
    if (!wrapper || !refreshedColumn) return;
    const collapsed = wrapper.classList.contains('boost-sd__filter-option-itemwrapper--collapsed');
    requestAnimationFrame(() => {
      if (!button.isConnected || visible(document.getElementById('boost-sd__filter-tree-toggle-button'))
        || collapsed !== wrapper.classList.contains('boost-sd__filter-option-itemwrapper--collapsed')) return;
      wrapper.classList.toggle('boost-sd__filter-option-itemwrapper--collapsed', !collapsed);
      label?.classList.toggle('boost-sd__filter-option-label--collapsed', !collapsed);
      button.setAttribute('aria-expanded', String(collapsed));
    });
  }, true);
  const schedule = () => { if (!frame) frame = requestAnimationFrame(sync); };
  new MutationObserver(schedule).observe(document.querySelector('.main-content') || document.body,
    {childList: true, subtree: true, attributes: true, attributeFilter: ['style']});
  window.addEventListener('resize', schedule);
  window.addEventListener('afterRenderHtmlForFilter', schedule);
  schedule();
})();

// Gallery2: return keyboard focus after the existing offer form closes.
// The vendor still owns opening, closing, submission and tracking.
(() => {
  if (String(window.Shopify?.theme?.id) !== '206763196764') return;
  const hostId = 'app-embed-container-1132889';
  const teaserSelector = '[data-testid="form-teaser"]';
  let connected = false;
  const connect = () => {
    if (connected) return true;
    const host = document.getElementById(hostId);
    const root = host?.shadowRoot;
    if (!root) return false;
    connected = true;
    let launched = false;
    let previousStep = root.querySelector('#app-embed')?.dataset.currentStep;
    let pending = false;
    let frame = 0;
    const cancel = () => { pending = false; };
    const restore = () => {
      if (!pending) return;
      const active = document.activeElement;
      // Respect a visitor who has already clicked or tabbed elsewhere.
      if (active && active !== document.body && active !== document.documentElement && active !== host) {
        cancel();
        return;
      }
      const trigger = root.querySelector(teaserSelector);
      if (!trigger?.isConnected || !trigger.getClientRects().length
          || getComputedStyle(trigger).visibility === 'hidden') return;
      pending = false;
      trigger.focus({preventScroll: true});
    };
    const sync = () => {
      const step = root.querySelector('#app-embed')?.dataset.currentStep;
      if (step === 'tease' && previousStep && previousStep !== 'tease' && launched) {
        pending = true;
        launched = false;
      }
      previousStep = step;
      restore();
      // A vendor render may make the teaser visible on the following frame.
      if (pending && !frame) frame = requestAnimationFrame(() => { frame = 0; restore(); });
    };
    root.addEventListener('click', event => {
      if (event.composedPath().some(element => element?.matches?.(teaserSelector))) {
        launched = true;
        pending = false;
      }
    }, true);
    document.addEventListener('focusin', event => {
      if (pending && !event.composedPath().includes(host)) cancel();
    }, true);
    document.addEventListener('pointerdown', event => {
      if (pending && !event.composedPath().includes(host)) cancel();
    }, true);
    document.addEventListener('keydown', event => {
      if (pending && event.key === 'Tab') cancel();
    }, true);
    new MutationObserver(sync).observe(root, {
      childList: true, subtree: true, attributes: true,
      attributeFilter: ['data-current-step', 'class', 'style', 'hidden']
    });
    return true;
  };
  if (!connect()) {
    const discovery = new MutationObserver(() => { if (connect()) discovery.disconnect(); });
    discovery.observe(document.body, {childList: true, subtree: true});
    window.addEventListener('load', () => { if (connect()) discovery.disconnect(); }, {once: true});
  }
})();
